export default __webpack_public_path__ + "static/gm-c261469fd19cb94ecf5e45b4739e792f.svg";